
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.75 24a3.747 3.747 0 01-2.998-1.5 3.754 3.754 0 01-3.75-3.75V8.25a3.754 3.754 0 013.75-3.75A3.747 3.747 0 016.75 3h1.5c.823 0 1.607.267 2.25.752V2.25A2.252 2.252 0 0112.75 0h5.379a2.24 2.24 0 011.591.66l.621.62c.425.426.659.991.659 1.592v1.705a3.744 3.744 0 012.998 3.673v10.5a3.754 3.754 0 01-3.75 3.75h-9A3.747 3.747 0 018.25 24h-1.5zm0-19.5A2.252 2.252 0 004.5 6.75v13.5a2.252 2.252 0 002.25 2.25h1.5a2.252 2.252 0 002.25-2.25V6.75A2.252 2.252 0 008.25 4.5h-1.5zM20.248 21a2.252 2.252 0 002.25-2.25V8.25A2.252 2.252 0 0020.248 6h-8.326c.052.248.078.499.078.75v13.5c0 .251-.026.502-.078.75h8.326zM3.056 6.113A2.258 2.258 0 001.502 8.25v10.5c0 .988.65 1.841 1.554 2.137A3.687 3.687 0 013 20.25V6.75c0-.213.019-.426.056-.637zM19.5 4.5V2.872a.758.758 0 00-.219-.531l-.621-.62a.746.746 0 00-.532-.221H12.75a.75.75 0 00-.75.75V4.5h7.5z"}}),_c('path',{attrs:{"d":"M15 9a.75.75 0 010-1.5h4.5a.75.75 0 010 1.5H15zM19.125 14.25c-.62 0-1.125-.505-1.125-1.125a1.127 1.127 0 011.171-1.122l.024.002a1.117 1.117 0 011.055 1.12c0 .62-.505 1.125-1.125 1.125zM19.125 18c-.62 0-1.125-.505-1.125-1.125a1.127 1.127 0 011.174-1.122l.008.001a1.121 1.121 0 011.068 1.121c0 .62-.505 1.125-1.125 1.125zM15.375 14.25c-.62 0-1.125-.505-1.125-1.125 0-.599.469-1.091 1.069-1.121a.546.546 0 01.056-.004c.62 0 1.125.505 1.125 1.125s-.505 1.125-1.125 1.125z"}}),_c('circle',{attrs:{"cx":"15.375","cy":"16.875","r":"1.125"}})])
          )
        }
      }
    